import { render, staticRenderFns } from "./SensitiveRule.vue?vue&type=template&id=81bfdd42&"
import script from "./SensitiveRule.vue?vue&type=script&lang=ts&"
export * from "./SensitiveRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports